import $ from "jquery";
$(document).ready(function () {
    $("body").on("submit", ".newsletter-block form", function (e) {
        var form = $(e.currentTarget);
        var email = form.find(".newsletter-email");
        var language = form.find(".newsletter-language");
        e.preventDefault();
        form.find("button").addClass("wait");
        $.post("/api/newsletter/subscribe", { email: email.val(), language: language.val() }).done(function (data) {
            form.find("button").removeClass("wait").addClass("success");
            setTimeout(function () {
                email.val("");
                form.find("button").removeClass("success");
            }, 5000);
        });
    });
});
